import axios from 'axios';
import {
  BRING_YOUR_FRIEND_REQUEST,
  BRING_YOUR_FRIEND_SUCCESS,
  BRING_YOUR_FRIEND_ERROR,
  BRING_YOUR_FRIEND_AMOUNT_REQUEST,
  BRING_YOUR_FRIEND_AMOUNT_SUCCESS,
  BRING_YOUR_FRIEND_AMOUNT_ERROR,
  REFERRED_FRIENDS_REQUEST,
  REFERRED_FRIENDS_SUCCESS,
  REFERRED_FRIENDS_ERROR,
  FETCH_PREDICTA_BONUS_CAMPAIGN_REQUEST,
  FETCH_PREDICTA_BONUS_CAMPAIGN_SUCCESS,
  FETCH_PREDICTA_BONUS_CAMPAIGN_FAILURE,
  FETCH_PREDICTA_SUGGESTION_REQUEST,
  FETCH_PREDICTA_SUGGESTION_SUCCESS,
  FETCH_PREDICTA_SUGGESTION_FAILURE,
} from 'Store/constants';
import errorMessage from './errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getBringYourFriend = customerId => async dispatch => {
  try {

    dispatch({
      type: BRING_YOUR_FRIEND_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/users/campaign/bring-your-friend/${customerId}`);

    dispatch({
      type: BRING_YOUR_FRIEND_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    console.log('error', e);

    dispatch({
      type: BRING_YOUR_FRIEND_ERROR,
      payload: errorMessage
    });
  }
};

export const getReferredFriends = customerId => async dispatch => {
  try {

    dispatch({
      type: REFERRED_FRIENDS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/users/campaign/bring-your-friend/referred-friends/${customerId}`);

    dispatch({
      type: REFERRED_FRIENDS_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    console.log('error', e);

    dispatch({
      type: REFERRED_FRIENDS_ERROR,
      payload: errorMessage
    });
  }
};


export const getBringYourFriendAmount = customerId => async dispatch => {
  try {

    dispatch({
      type: BRING_YOUR_FRIEND_AMOUNT_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/users/campaign/bring-your-friend/amount/${customerId}`);

    dispatch({
      type: BRING_YOUR_FRIEND_AMOUNT_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    console.log('error', e);

    dispatch({
      type: BRING_YOUR_FRIEND_AMOUNT_ERROR,
      payload: errorMessage
    });
  }
};

export const fetchPredictaBonusCampaign = () => async (dispatch, getState) => {

  try {
    dispatch({ type: FETCH_PREDICTA_BONUS_CAMPAIGN_REQUEST });

    const response = await axios.get(`${API_GATEWAY}/users/campaign/predicta-bonus/user/v2`);

    dispatch({
      type: FETCH_PREDICTA_BONUS_CAMPAIGN_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_PREDICTA_BONUS_CAMPAIGN_FAILURE,
      payload: error.response?.data
    });
  }
};

export const fetchPredictaSuggestion = () => async (dispatch, getState) => {

  try {
    dispatch({ type: FETCH_PREDICTA_SUGGESTION_REQUEST });

    const response = await axios.get(`${API_GATEWAY}/campaigns/predicta/target-audience/exists`);

    dispatch({
      type: FETCH_PREDICTA_SUGGESTION_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: FETCH_PREDICTA_SUGGESTION_FAILURE,
      payload: error.response?.data
    });
  }
};
